<template>
  <div class="main">
    <GoBack :name="name" :type="2" :path="`/mobile/accountSettings`"></GoBack>
    <div class="account-content"></div>
    <div class="main-box" v-if="type === 1">
      <div class="input-box">
        <input v-model="oldPassword" placeholder="原密码" />
      </div>
      <div class="input-box">
        <input v-model="newPassword" placeholder="新密码" />
      </div>
      <div class="input-box">
        <input v-model="confirmPassword" placeholder="确认密码" />
      </div>
      <button class="btn1" @click="changePassword">确认修改</button>
    </div>

    <div class="main-box" v-if="type === 2">
      <div class="input-box">
        <input v-model="params1.name" placeholder="姓名" />
      </div>
      <div class="input-box">
        <input v-model="params1.alipay" placeholder="支付宝账户" />
      </div>
      <div class="input-title">仅首次可修改</div>
      <button class="btn1" :disabled="isAlipay" @click="setAlipay">绑定</button>
    </div>
  </div>
</template>
<script>
import GoBack from "@/components/goBack";
import {
  setChangePassword,
  setAlipay,
  getProfile,
  getAlipay,
} from "@/api/mobile";
export default {
  data() {
    return {
      name: "",
      type: null,
      oldPassword: null,
      newPassword: null,
      confirmPassword: null,
      params1: {
        id: null,
        name: null,
        alipay: null,
        idCard: null,
        isDefault: true,
      },
      profileInfo: {
        id: null,
        name: null,
        gender: null,
        birthday: null,
        provinceId: null,
        cityId: null,
        districtId: null,
      },
      isAlipay: false,
    };
  },
  components: { GoBack },
  methods: {
    //获取支付宝信息
    async getAlipay() {
      await getAlipay().then((res) => {
        if (res.code === 200) {
          if (res.data.alipay) {
            this.params1.alipay = res.data.alipay;
            this.name.alipay = res.data.name;
            this.isAlipay = true;
          }
        }
      });
    },
    //获取基础信息
    async getProfile() {
      await getProfile().then((res) => {
        if (res.code) {
          this.profileInfo = {
            id: res.data.id,
            name: res.data.name,
            gender: res.data.gender || null,
            birthday: res.data.birthday,
            provinceId: res.data.provinceId || null,
            cityId: res.data.cityId || null,
            districtId: res.data.districtId || null,
          };

          this.params1 = {
            id: this.profileInfo.id,
            name: this.profileInfo.name,
            alipay: null,
            idCard: null,
            isDefault: true,
          };
        }
      });
    },
    //修改密码
    changePassword() {
      setChangePassword({
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
        confirmPassword: this.confirmPassword,
      }).then((res) => {
        if (res.code === 200) {
          this.$toast("修改成功");
          this.$router.push("/mobile");
        }
      });
    },
    //修改支付宝信息
    setAlipay() {
      setAlipay(this.params1).then(async (res) => {
        if (res.code === 200) {
          this.$toast("绑定成功");
        }
      });
    },
  },
  async created() {
    switch (this.$route.query.type) {
      case "1":
        this.type = 1;
        this.name = "修改密码";
        break;
      case "2":
        this.type = 2;
        this.name = "绑定支付宝";
        break;
    }
    await this.getProfile();
    await this.getAlipay();
  },
};
</script>
<style lang="scss" scoped>
.input-title {
  color: #ff2e26;
  font-size: 12px;
  font-weight: bolder;
}
.main {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #f8f8f8;
  .account-content {
    position: absolute;
    width: 100%;
    background-color: #fff;
    top: 0;
    z-index: 0;
    padding-top: 50px;
    box-sizing: border-box;
  }
  .main-box {
    padding: 0 15px;
    padding-top: 20px;
    .input-box {
      width: 100%;
      height: 46px;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      position: relative;
      margin-bottom: 12px;
      input {
        width: 100%;
        height: 46px;
        padding: 0 12px;
        box-sizing: border-box;
        border: none;
        outline: none;
        font-size: 14px;
        color: #232323;
      }
      input::placeholder {
        color: #cccccc; /* 灰色的placeholder文本 */
        opacity: 1;
      }
      .input-right1 {
        padding-right: 98px;
      }
      .disabled {
        color: #808080;
      }
      .right {
        position: absolute;
        color: #8846ff;
        font-size: 14px;
        right: 16px;
        top: 13px;
      }
    }
    .btn1 {
      width: 299px;
      height: 42px;
      background: linear-gradient(138deg, #bb95ff 0%, #8846ff 100%);
      border-radius: 25px 25px 25px 25px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      color: #fff;
      font-size: 18px;
      margin-top: 28px;
      padding: 0;
      border: none;
    }
  }
}
</style>